import type { ConstValues } from './helpers';
export const TIME_PERIOD_UNIT = {
  HOUR: 'hour',
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
} as const;

export const getTimePeriodOptions: Record<string, string> = {
  [TIME_PERIOD_UNIT.HOUR]: 'Hours',
  [TIME_PERIOD_UNIT.DAY]: 'Days',
  [TIME_PERIOD_UNIT.WEEK]: 'Weeks',
};

export type TimePeriodUnit = ConstValues<typeof TIME_PERIOD_UNIT>;

export const FREQUENCY_CAPPING_FIELDS = {
  IMPRESSIONS_LIMIT: 'impressions_limit',
  TIME_PERIOD_UNIT: 'time_period_unit',
  TIME_PERIOD_VALUE: 'time_period_value',
} as const;

export type FrequencyCappingFields = ConstValues<typeof FREQUENCY_CAPPING_FIELDS>;

export type FrequencyCappingData = {
  [FREQUENCY_CAPPING_FIELDS.IMPRESSIONS_LIMIT]: string;
  [FREQUENCY_CAPPING_FIELDS.TIME_PERIOD_UNIT]: TimePeriodUnit | '';
  [FREQUENCY_CAPPING_FIELDS.TIME_PERIOD_VALUE]: number | string;
};

export type FrequencyCapping = FrequencyCappingData[];
